import { TermsDetails } from '@api/api.types'
import { useSuspenseWalletTerms } from '@src/queries/terms'

export const mapWalletTerms = (termsData: TermsDetails[]) => {
  return termsData.map(({ name, version }) => ({ name, version }))
}

export const useSuspenseMappedWalletTerms = () => {
  return useSuspenseWalletTerms(mapWalletTerms)
}
